import * as React from 'react';
import { FormattedMessage } from 'react-intl';

const RICH_TAGS = {
  break: <br />,
  strong: (chunks: React.ReactNode[]) => <strong>{chunks}</strong>,
  u: (chunks: React.ReactNode[]) => <u>{chunks}</u>,
};

interface RichMessageProps {
  id?: string;
  values?: object;
  defaultMessage?: string;
}

function RichMessage({ id, values, ...rest }: RichMessageProps) {
  return <FormattedMessage id={id} values={{ ...RICH_TAGS, ...values }} {...rest} />;
}
export default RichMessage;
